import { module } from 'modujs';
import Channels from '../base/channels';
import gsap from 'gsap';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };

    this.listen();

    new ResizeObserver(() => {
      this.listen();
    }).observe(this.DOM.view);
  }

  listen() {
    gsap.delayedCall(0.2, () => {
      Channels.emit('scroll::soft::refresh');
    });
  }
}
